import { render } from "./InputTextArea.vue?vue&type=template&id=231f254e"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"
script.render = render

export default script